import React from 'react';
import styles from './WalletPage.module.css';

const WalletPage = () => {
  return (
    <div className={styles.walletPage}>
      <div className={styles.walletContainer}>
        <div className={styles.comingSoonContainer}>
          <div className={styles.comingSoonIcon}>💳</div>
          <h1 className={styles.comingSoonTitle}>My Wallet</h1>
          <h2 className={styles.comingSoonSubtitle}>Coming Soon!</h2>
          <p className={styles.comingSoonText}>
            We're building an amazing wallet experience for you. Stay tuned for exciting features like balance tracking, transactions, and more!
          </p>
        </div>
      </div>
    </div>
  );
};

export default WalletPage;
